var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-tree"},[(1 === 1)?_c('ritm-tree',{attrs:{"loading":_vm.loading,"tree-data":_vm.treeData,"active-nodes":_vm.activeNodes,"no-animations":"","node-click":_vm.nodeClick,"icon-by-item":_vm.iconByItem,"edit-mode":""},on:{"updateNode":_vm.updateProfileTreeItem}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }